(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyLocationInfoController', CompanyLocationInfoController);

    CompanyLocationInfoController.$inject = ['$rootScope', '$state', '$timeout', '$scope', '$stateParams', 'LocationInfo', 'SelectorData', 'SelectorDataQuery', 'CompanyInfoQuery', 'LocationInfoCustom', 'entity'];

    function CompanyLocationInfoController($rootScope, $state, $timeout, $scope, $stateParams, LocationInfo, SelectorData, SelectorDataQuery, CompanyInfoQuery, LocationInfoCustom, entity) {

        var vm = this;
        vm.scope = $scope;

        vm.companyInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.province_changed = province_changed;
        vm.country_changed = country_changed;
        vm.selectordata = SelectorData.query();

        vm.okModal = okModal;
        vm.closeModal = closeModal;

        $rootScope.$broadcast('hideNavBar');


        function clear() {
            // $uibModalInstance.dismiss('cancel');
        }

        function country_changed() {
            //if(vm.companyInfo.locationInfo.countryId!=null)
            //vm.provinceList=SelectorDataQuery.findByTypeAndParent('province',vm.companyInfo.locationInfo.countryId).query();
            //if(vm.companyInfo.locationInfo.stateId!=null)
            //vm.cityList=SelectorDataQuery.findByTypeAndParent('city',vm.companyInfo.locationInfo.stateId).query();
        }

        function province_changed() {
            //vm.cityList=SelectorDataQuery.findByTypeAndParent('city',vm.companyInfo.locationInfo.stateId).query();
        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.companyInfo.locationInfo.id !== null) {
                    LocationInfo.update(vm.companyInfo.locationInfo, onSaveSuccess, onSaveError);
                } else {
                    LocationInfoCustom.saveWithCompany().save(vm.companyInfo.locationInfo, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:locationInfoUpdate', result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }

    }
})();
